/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, useEffect, useRef } from 'react';
import { ColumnDef } from '@tanstack/react-table';
import FeatherIcon from 'feather-icons-react';
import { Form, Offcanvas } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import { useNavigationType } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { invoceBreadcrumbItems } from 'data/invoce';
import PrintingFilter from './filters/printing';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import Button from 'components/base/Button';
import productSearchService from 'service/productSearch';
import { InvoiceType } from 'data/invoce';
import { showAlert } from 'store/alert/alert.thunk';
import invoiceService from 'service/invoice';
import useFocusRefs from 'utils/useFocusRefs';
import SupperModal from 'components/modals/SupperModal';
import { tableSavedDataActions } from 'store/tableSavedData/tableSavedData.slice';
import { useAppContext } from 'providers/AppProvider';
import FillInInvoiceItem from './FillInInvoiceItem';

import './styles.scss';
import AdvanceTable from 'components/base/AdvanceTable';
import AdvanceTableFooter from 'components/base/AdvanceTableFooter';

const PurchaseInvoce = () => {
  const { t } = useTranslation();
  const {
    config: { theme }
  } = useAppContext();

  const { pathname, state } = useLocation();
  const navigate = useNavigate();
  const newInvoiceId = pathname.split('/').pop();
  const { invoice_pid } = state;

  const { setRef, focusRef } = useFocusRefs();

  const [productInvoiceData, setProductInvoiceData] = useState<any[]>([]);
  const [modalCreate, setModalCreate] = useState(false);
  const [isVatPayerValue, setIsVatPayerValue] = useState(false);
  const [ndsData, setNdsData] = useState('');
  const [ndsPrice, setNdsPrice] = useState('');
  const [ndsPriceWholsale, setNdsPriceWholsale] = useState('');
  const [ndsTransfer, setNdsTransfer] = useState('');

  const [openSupperModal, setOpenSupperModal] = useState(false);
  const [confirmToDelete, setConfirmToDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  const [saleToMinus, setSaleToMinus] = useState(false);
  const [isForced, setIsForced] = useState(false);
  const [isTabToWhosale, setIsTabToWhosale] = useState(false);
  const [isEnter, setIsEnter] = useState(false);
  const [isPageDown, setIsPageDown] = useState(false);
  const [openFillIn, setOpenFillIn] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>();

  const dispatch: Dispatch<any> = useDispatch();
  const navType = useNavigationType();
  const barcodeInputRef = useRef<HTMLInputElement>(null);
  const tableRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (navType === 'PUSH' || navType === 'REPLACE') {
      setProductInvoiceData([]);
    }
  }, [navType]);

  console.log('productInvoiceData===>', productInvoiceData);

  const handleRemoveProductItem = (indexToRemove: number) => {
    const itemToRemove = productInvoiceData[indexToRemove];

    dispatch(
      tableSavedDataActions.removeItemFromTableData({
        id: newInvoiceId, // Use dynamic id as needed
        barcodeUser: itemToRemove.barcode_user // Or use the guid if that's the unique identifier
      })
    );

    setProductInvoiceData(
      productInvoiceData.filter((_: any, index: any) => index !== indexToRemove)
    );
  };
  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      if (event.key === 'F5') {
        event.preventDefault();

        // Ensure input blur before opening the modal
        const activeElement = document.activeElement as HTMLInputElement;
        if (activeElement && activeElement.tagName === 'INPUT') {
          activeElement.blur();
        }

        setTimeout(() => {
          setOpenSupperModal(true);
        }, 50); // Small delay to allow state updates
      } else if (event.key === 'F4') {
        event.preventDefault();

        // Ensure input blur before saving
        const activeElement = document.activeElement as HTMLInputElement;
        if (activeElement && activeElement.tagName === 'INPUT') {
          activeElement.blur();
        }

        setTimeout(() => {
          handleSave();
        }, 50); // Delay ensures state update before saving
      }
    };

    window.addEventListener('keydown', handleKeyPress);

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  const invoiceTableColumns: ColumnDef<InvoiceType>[] = [
    {
      id: 'action',
      cell: rowData => (
        <div>
          <Button
            variant="hover"
            onClick={() => handleRemoveProductItem(+rowData?.row?.id)}
          >
            <FeatherIcon
              icon="trash-2"
              className="cursor-pointer text-danger"
              size={18}
            />
          </Button>
        </div>
      ),
      meta: {
        headerProps: { style: { width: '5%' } },
        cellProps: { className: 'text-900 p-2' }
      }
    },
    {
      accessorKey: 'order_number',
      header: '№',
      cell: rowData => {
        const orderNumber = rowData.row.index + 1; // Calculate the order number based on the row index
        return <div>{orderNumber}</div>;
      },
      meta: {
        headerProps: { style: { width: '5%' } },
        cellProps: { className: 'text-900 p-1 text-center' }
      }
    },
    {
      accessorKey: 'name',
      header: t('products'),
      // cell: rowData => {
      //   const amount: any = rowData.getValue() ?? '';

      //   const [value, setValue] = useState(amount);
      //   const [inputWidth, setInputWidth] = useState('150px'); // Set a default fixed width
      //   const [focused, setFocused] = useState(false);

      //   useEffect(() => {
      //     if (focused) {
      //       const span = document.createElement('span');
      //       span.style.visibility = 'hidden';
      //       span.style.whiteSpace = 'pre';
      //       span.style.fontSize = '14px'; // Ensure this matches your input's font size
      //       span.style.fontFamily = 'Arial'; // Ensure this matches your input's font family
      //       span.innerText = value;

      //       document.body.appendChild(span);
      //       const width = span.offsetWidth + 38; // Add some padding
      //       setInputWidth(`${width}px`);
      //       document.body.removeChild(span);
      //     }
      //   }, [value, focused]);

      //   const onBlur = (e: React.ChangeEvent<HTMLInputElement>, index: any) => {
      //     const { name, value } = e.target;
      //     const updatedItems = productInvoiceData.map((item: any, i: any) => {
      //       if (i === +index) {
      //         return { ...item, [name]: value };
      //       }
      //       return item;
      //     });

      //     setProductInvoiceData(updatedItems);
      //     setFocused(false); // Remove focus to stop dynamic width calculation
      //   };

      //   const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      //     setValue(e.target.value);
      //   };

      //   const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
      //     e.target.select();
      //     setFocused(true); // Set focus to dynamically calculate the width
      //   };

      //   return (
      //     <div>
      //       <Form.Group>
      //         <Form.Control
      //           type="text"
      //           name="name"
      //           value={value}
      //           onChange={handleChange}
      //           onBlur={(e: any) => onBlur(e, rowData.row?.id)}
      //           onFocus={handleFocus}
      //           style={{
      //             width: inputWidth,
      //             whiteSpace: 'nowrap',
      //             transition: 'width 0.2s ease-in-out' // Smooth transition
      //           }}
      //           autoComplete="off"
      //         />
      //       </Form.Group>
      //     </div>
      //   );
      // },
      meta: {
        cellProps: {
          className: 'text-900 p-1',
          style: { whiteSpace: 'nowrap' }
        }
      }
    },

    {
      accessorKey: 'barcode_user',
      header: t('barcode'),
      meta: {
        cellProps: { className: 'text-900 p-1' }
      }
    },
    {
      accessorKey: 'serial_number',
      header: t('serial_number'),
      cell: ({ row: { original } }) => {
        const { serial_number, quantity } = original;
        return (
          <div>
            {serial_number?.length > 0 && +quantity !== 0 ? (
              <Button
                variant="soft-primary"
                onClick={() => {
                  setOpenFillIn(true);
                  setSelectedRow(original);
                }}
              >
                {t('edit')}
              </Button>
            ) : (
              <Button
                variant="soft-primary"
                onClick={() => {
                  setOpenFillIn(true);
                  setSelectedRow(original);
                }}
              >
                {t('fill_in')}
              </Button>
            )}
          </div>
        );
      },
      meta: {
        cellProps: {
          className: 'text-900',
          style: { whiteSpace: 'nowrap' }
        }
      }
    },

    {
      accessorKey: 'sale_with_partion_code',
      header: t('sale_with_partion_code'),
      cell: rowData => {
        const amount: any = rowData?.getValue() ?? false;
        const [value, setValue] = useState(amount);

        const handleCheckboxChange = (
          e: React.ChangeEvent<HTMLInputElement>,
          index: any
        ) => {
          const checked = e.target.checked;
          setValue(checked);

          const updatedItems = productInvoiceData.map((item: any, i: any) => {
            if (i === +index) {
              return { ...item, sale_with_partion_code: checked };
            }
            return item;
          });

          setProductInvoiceData(updatedItems);
        };
        return (
          <div>
            <Form.Group className="printing-check">
              <Form.Check
                type="switch"
                checked={value}
                onChange={e => handleCheckboxChange(e, rowData.row?.id)}
                className="cursor-pointer"
              />
            </Form.Group>
          </div>
        );
      },
      meta: {
        cellProps: { className: 'text-900 text-center' }
      }
    },

    {
      accessorKey: 'units',
      header: t('short_measure_unit'),
      meta: {
        cellProps: { className: 'text-900 p-1' }
      }
    },

    {
      accessorKey: 'current_balance',
      header: t('short_current_balance'),
      meta: {
        cellProps: { className: 'text-900 p-1' }
      }
    },

    {
      accessorKey: 'quantity',
      header: t('short_quantity'),
      cell: rowData => {
        const amount: any = rowData.getValue() ?? '1';

        const measureUnitKindId = rowData?.row?.original?.measure_unit_kind_id; // check to vesavoy id
        const packageQuantity = rowData?.row?.original?.amount;

        const [value, setValue] = useState(amount);

        const updateProductInvoiceData = (
          name: string,
          value: string,
          index: any
        ) => {
          const updatedItems = productInvoiceData.map((item: any, i: any) => {
            if (i === +index) {
              return {
                ...item,
                [name]: value,
                serial_number: +value === 0 ? [] : item.serial_number
              };
            }
            return item;
          });
          setProductInvoiceData(updatedItems);
        };

        const onBlur = (e: React.ChangeEvent<HTMLInputElement>, index: any) => {
          const { name, value } = e.target;
          updateProductInvoiceData(name, value, index);
        };

        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
          const newValue = e.target.value;

          // Regex to match negative numbers, decimals, and fractions
          const numberPattern = /^-?\d*\.?\d*$/;
          const remainderPattern = /^-?\d*\/?\d*$/;

          const packageQuantityNumber = Number(packageQuantity);

          if (measureUnitKindId === '3c7cee55-ad41-4ee3-a409-a7bb5f428b36') {
            if (remainderPattern.test(newValue)) {
              const [numerator, denominator] = newValue.split('/').map(Number);
              console.log('numerator', numerator);
              // Ensure the fraction's denominator does not exceed packageQuantity
              if (
                denominator > packageQuantityNumber ||
                denominator === packageQuantityNumber
              ) {
                return; // Do nothing if the denominator is invalid
              }

              setValue(newValue); // Set value if fraction is valid
            }
          } else {
            // Handle normal numbers
            if (numberPattern.test(newValue)) {
              setValue(newValue);
            }
          }
        };

        const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
          if (isEnter) {
            if (e.key === 'Enter') {
              e.preventDefault();
              const { name, value } = e.target as HTMLInputElement;
              try {
                updateProductInvoiceData(name, value, rowData.row?.id);
              } catch (error) {
                console.log('error===>', error);
              }
              // focusRef(
              //   // measureUnitKindId === '3c7cee55-ad41-4ee3-a409-a7bb5f428b36'
              //   //   ? `amount_${rowData.row.id}`
              //   // :
              //   `package_amount_${rowData.row.id}`
              // );
              setTimeout(() => {
                focusRef(`package_amount_${rowData.row.id}`);
              }, 0);
            }
            setTimeout(() => {
              if (e.key === 'Tab' && barcodeInputRef.current) {
                barcodeInputRef.current.focus();
                barcodeInputRef.current.select();
              }
            }, 0);
          } else {
            if (e.key === 'Tab') {
              e.preventDefault();
              const { name, value } = e.target as HTMLInputElement;
              try {
                updateProductInvoiceData(name, value, rowData.row?.id);
              } catch (error) {
                console.log('error===>', error);
              }
              // focusRef(
              //   // measureUnitKindId === '3c7cee55-ad41-4ee3-a409-a7bb5f428b36'
              //   //   ? `amount_${rowData.row.id}`
              //   // :
              //   `package_amount_${rowData.row.id}`
              // );
              setTimeout(() => {
                focusRef(`package_amount_${rowData.row.id}`);
              }, 0);
            }
            setTimeout(() => {
              if (e.key === 'Enter' && barcodeInputRef.current) {
                barcodeInputRef.current.focus();
                barcodeInputRef.current.select();
              }
            }, 0);
          }
        };
        return (
          <div style={{ width: '70px' }}>
            <Form.Group>
              <Form.Control
                type="text"
                name="quantity"
                value={value}
                onChange={handleChange}
                onBlur={(e: any) => {
                  if (value === '') {
                    setValue('1'); // Reset to default value if left empty
                  }
                  onBlur(e, rowData.row?.id);
                }}
                onFocus={e => e.target.select()}
                onKeyDown={handleKeyDown}
                ref={setRef(`quantity_${rowData.row?.id}`)}
                min="1"
                autoComplete="off"
                style={{ textAlign: 'right' }}
              />
            </Form.Group>
          </div>
        );
      },
      meta: {
        cellProps: { className: 'text-900 p-1' }
      }
    },
    {
      accessorKey: 'amount',
      header: t('short_quantity_package'),
      cell: rowData => {
        const amount: any = rowData.getValue() ?? '1';

        // it is id for check update or no (i check it to static Упаковка "3c7cee55-ad41-4ee3-a409-a7bb5f428b36")
        const measureUnitKindId = rowData?.row?.original.measure_unit_kind_id;

        const [value, setValue] = useState(amount);

        const updateProductInvoiceData = (
          name: string,
          value: string,
          index: any
        ) => {
          const updatedItems = productInvoiceData.map((item: any, i: any) => {
            if (i === +index) {
              return { ...item, [name]: +value };
            }
            return item;
          });
          setProductInvoiceData(updatedItems);
        };

        const onBlur = (e: React.ChangeEvent<HTMLInputElement>, index: any) => {
          const { name, value } = e.target;
          updateProductInvoiceData(name, value, index);
        };

        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
          const newValue = e.target.value;
          if (/^\d*$/.test(newValue)) {
            // Allow empty string for intermediate state
            setValue(newValue);
          }
        };

        const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
          if (isEnter) {
            if (e.key === 'Enter') {
              const { name, value } = e.target as HTMLInputElement;
              updateProductInvoiceData(name, value, rowData.row?.id);
              setTimeout(() => {
                focusRef(`package_amount_${rowData.row.id}`);
              }, 0);
            }
            setTimeout(() => {
              if (e.key === 'Tab' && barcodeInputRef.current) {
                barcodeInputRef.current.focus();
                barcodeInputRef.current.select();
              }
            }, 0);
          } else {
            if (e.key === 'Tab') {
              const { name, value } = e.target as HTMLInputElement;
              updateProductInvoiceData(name, value, rowData.row?.id);
              setTimeout(() => {
                focusRef(`package_amount_${rowData.row.id}`);
              }, 0);
            }
            setTimeout(() => {
              if (e.key === 'Enter' && barcodeInputRef.current) {
                barcodeInputRef.current.focus();
                barcodeInputRef.current.select();
              }
            }, 0);
          }
        };
        return (
          <div>
            {measureUnitKindId === '3c7cee55-ad41-4ee3-a409-a7bb5f428b36' &&
            rowData?.row?.original.is_product === false ? (
              <Form.Group>
                <Form.Control
                  type="text"
                  name="amount"
                  value={value}
                  onChange={handleChange}
                  onBlur={(e: any) => {
                    if (value === '') {
                      setValue('1'); // Reset to default value if left empty
                    }
                    onBlur(e, rowData.row?.id);
                  }}
                  ref={setRef(`amount_${rowData.row?.id}`)}
                  onKeyDown={handleKeyDown}
                  onFocus={e => e.target.select()}
                  min="1"
                  autoComplete="off"
                  style={{ textAlign: 'right' }}
                />
              </Form.Group>
            ) : (
              <span className="ms-3">{amount}</span>
            )}
          </div>
        );
      },
      meta: {
        cellProps: { className: 'text-900 p-1' }
      }
    },
    {
      accessorKey: 'package_amount',
      header: t('short_price_in'),
      cell: rowData => {
        const amount: any = rowData.getValue() ?? '0';
        /* prettier-ignore */
        const formatWithSpaces = (val: any) => {
          const cleanValue = String(val || '').replace(/[^0-9.]/g, ''); // Remove non-numeric chars except .
          if (!cleanValue) return '';
          const [integerPart, decimalPart] = cleanValue.includes('.')
            ? cleanValue.split('.')
            : [cleanValue, ''];
          const formattedInteger = integerPart.replace(
            /\B(?=(\d{3})+(?!\d))/g,
            ' '
          );
          return decimalPart
            ? `${formattedInteger}.${decimalPart}`
            : formattedInteger;
        };

        // Function to remove spaces for state storage
        const removeSpaces = (val: string) => {
          return val.replace(/\s/g, '');
        };

        const [value, setValue] = useState(formatWithSpaces(String(amount)));

        const updateProductInvoiceData = (
          name: string,
          sanitizedValue: string,
          index: any
        ) => {
          const numericValue = parseFloat(sanitizedValue) || 0;
          const updatedItems = productInvoiceData.map((item: any, i: any) => {
            if (i === +index) {
              return {
                ...item,
                [name]: numericValue
              };
            }

            return item;
          });

          setProductInvoiceData(updatedItems);
        };

        const sanitizeValue = (inputValue: string): string => {
          if (!inputValue) return '0';

          // Replace the first comma (if exists) with a dot (only if followed by a digit)
          let cleanedValue = removeSpaces(inputValue).replace(
            /(\d),(?=\d)/,
            '$1.'
          );

          // Remove all remaining commas
          cleanedValue = cleanedValue.replace(/,/g, '');

          // Ensure only one valid decimal point (keep only the last one)
          const parts = cleanedValue.split('.');
          if (parts?.length > 2) {
            cleanedValue =
              parts.slice(0, -1).join('') + '.' + parts[parts?.length - 1];
          }

          return cleanedValue || '0';
        };

        const onBlur = (e: React.ChangeEvent<HTMLInputElement>, index: any) => {
          console.log('index===>', index);

          const { name, value } = e.target;

          const sanitizedValue = sanitizeValue(value);
          updateProductInvoiceData(name, sanitizedValue, index);
          setValue(formatWithSpaces(sanitizedValue));
        };

        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
          const newValue = e.target.value;
          const cleanValue = removeSpaces(newValue);
          const decimalPattern = /^-?\d*[.]?\d*$/;
          if (decimalPattern.test(cleanValue)) {
            setValue(formatWithSpaces(cleanValue));
          }
        };

        const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
          if (isEnter) {
            if (e.key === 'Enter') {
              e.preventDefault(); // Prevent default Tab behavior

              const { name, value } = e.target as HTMLInputElement;
              const sanitizedValue = sanitizeValue(value); // Apply formatting
              const numericValue = parseFloat(sanitizedValue) || 0;

              const updatedItems = productInvoiceData.map(
                (item: any, i: any) => {
                  if (isForced === true) {
                    // updateProductInvoiceData(name, value, rowData.row.id);

                    if (i === +rowData.row?.id) {
                      return {
                        ...item,
                        [name]: numericValue // Use the sanitized value directly
                      };
                    }

                    // setTimeout(() => {
                    //   if (isTabToWhosale) {
                    //     focusRef(`all_cost_${rowData.row.id}`);
                    //   } else {
                    //     focusRef(`cost_${rowData.row?.id}`);
                    //   }
                    // }, 50);
                  } else {
                    if (i === +rowData.row?.id) {
                      const updatedItem = {
                        ...item,
                        [name]: numericValue
                      };

                      // Only update cost calculations if isForced is false
                      if (isTabToWhosale) {
                        updatedItem['all_cost'] =
                          (numericValue * +ndsPrice) / 100 + numericValue;
                      } else {
                        updatedItem['cost'] =
                          (numericValue * +ndsPriceWholsale) / 100 +
                          numericValue;
                      }

                      return updatedItem; // Ensure we return the modified object
                    }
                  }

                  return item; // Return unchanged item if not updated
                }
              );

              console.log('updatedItems', updatedItems);
              setProductInvoiceData(updatedItems);

              setTimeout(() => {
                if (isTabToWhosale) {
                  focusRef(`all_cost_${rowData.row.id}`);
                } else {
                  focusRef(`cost_${rowData.row?.id}`);
                }
              }, 50);
            }
            setTimeout(() => {
              if (e.key === 'Tab' && barcodeInputRef.current) {
                barcodeInputRef.current.focus();
                barcodeInputRef.current.select();
              }
            }, 0);
          } else {
            if (e.key === 'Tab') {
              e.preventDefault(); // Prevent default Tab behavior

              const { name, value } = e.target as HTMLInputElement;
              const sanitizedValue = sanitizeValue(value); // Apply formatting
              const numericValue = parseFloat(sanitizedValue) || 0;

              const updatedItems = productInvoiceData.map(
                (item: any, i: any) => {
                  if (isForced === true) {
                    // updateProductInvoiceData(name, value, rowData.row.id);

                    if (i === +rowData.row?.id) {
                      return {
                        ...item,
                        [name]: numericValue // Use the sanitized value directly
                      };
                    }

                    // setTimeout(() => {
                    //   if (isTabToWhosale) {
                    //     focusRef(`all_cost_${rowData.row.id}`);
                    //   } else {
                    //     focusRef(`cost_${rowData.row?.id}`);
                    //   }
                    // }, 50);
                  } else {
                    if (i === +rowData.row?.id) {
                      const updatedItem = {
                        ...item,
                        [name]: numericValue
                      };

                      // Only update cost calculations if isForced is false
                      if (isTabToWhosale) {
                        updatedItem['all_cost'] =
                          (numericValue * +ndsPrice) / 100 + numericValue;
                      } else {
                        updatedItem['cost'] =
                          (numericValue * +ndsPriceWholsale) / 100 +
                          numericValue;
                      }

                      return updatedItem; // Ensure we return the modified object
                    }
                  }

                  return item; // Return unchanged item if not updated
                }
              );

              console.log('updatedItems', updatedItems);
              setProductInvoiceData(updatedItems);

              setTimeout(() => {
                if (isTabToWhosale) {
                  focusRef(`all_cost_${rowData.row.id}`);
                } else {
                  focusRef(`cost_${rowData.row?.id}`);
                }
              }, 50);
            }
            setTimeout(() => {
              if (e.key === 'Enter' && barcodeInputRef.current) {
                barcodeInputRef.current.focus();
                barcodeInputRef.current.select();
              }
            }, 0);
          }
        };
        return (
          <div>
            <Form.Group className="position-relative">
              <Form.Control
                type="text"
                name="package_amount"
                value={value}
                onChange={handleChange}
                onBlur={(e: any) => onBlur(e, rowData.row?.id)}
                onFocus={e => e.target.select()}
                onKeyDown={handleKeyDown}
                ref={setRef(`package_amount_${rowData.row?.id}`)}
                autoComplete="off"
                style={{ textAlign: 'right' }}
              />
            </Form.Group>
          </div>
        );
      },
      meta: {
        cellProps: { className: 'text-900 p-1' }
      }
    },
    {
      accessorKey: 'cost',
      header: t('short_price_wholasale'),
      cell: rowData => {
        const amount: any = rowData.getValue() ?? '0';
        const { package_amount } = rowData.row.original;

        /* prettier-ignore */
        const formatWithSpaces = (val: any) => {
          const cleanValue = String(val || '').replace(/[^0-9.]/g, ''); // Remove non-numeric chars except .
          if (!cleanValue) return '';
          const [integerPart, decimalPart] = cleanValue.includes('.')
            ? cleanValue.split('.')
            : [cleanValue, ''];
          const formattedInteger = integerPart.replace(
            /\B(?=(\d{3})+(?!\d))/g,
            ' '
          );
          return decimalPart
            ? `${formattedInteger}.${decimalPart}`
            : formattedInteger;
        };

        // Function to remove spaces for state storage
        const removeSpaces = (val: string) => {
          return val.replace(/\s/g, '');
        };

        const [value, setValue] = useState(formatWithSpaces(String(amount)));

        const updateProductInvoiceData = (
          name: string,
          sanitizedValue: string,
          index: any
        ) => {
          const numericValue = parseFloat(sanitizedValue) || 0;
          const updatedItems = productInvoiceData.map((item: any, i: any) => {
            if (i === +index) {
              return {
                ...item,
                [name]: numericValue
              };
            }

            return item;
          });

          setProductInvoiceData(updatedItems);
        };

        const sanitizeValue = (inputValue: string): string => {
          if (!inputValue) return '0';

          // Replace the first comma (if exists) with a dot (only if followed by a digit)
          let cleanedValue = removeSpaces(inputValue).replace(
            /(\d),(?=\d)/,
            '$1.'
          );

          // Remove all remaining commas
          cleanedValue = cleanedValue.replace(/,/g, '');

          // Ensure only one valid decimal point (keep only the last one)
          const parts = cleanedValue.split('.');
          if (parts?.length > 2) {
            cleanedValue =
              parts.slice(0, -1).join('') + '.' + parts[parts?.length - 1];
          }

          return cleanedValue || '0';
        };

        const onBlur = (e: React.ChangeEvent<HTMLInputElement>, index: any) => {
          const { name, value } = e.target;

          const sanitizedValue = sanitizeValue(value);
          updateProductInvoiceData(name, sanitizedValue, index);
          setValue(sanitizedValue);
        };

        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
          const newValue = e.target.value;
          const cleanValue = removeSpaces(newValue);

          // Allow numbers, commas, and dots
          const decimalPattern = /^-?\d*[.]?\d*$/;
          if (decimalPattern.test(cleanValue)) {
            setValue(formatWithSpaces(cleanValue));
          }
        };

        const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
          if (isEnter) {
            if (e.key === 'Enter') {
              e.preventDefault(); // Prevent default Tab behavior

              const { name, value } = e.target as HTMLInputElement;
              const sanitizedValue = sanitizeValue(value); // Apply formatting
              const numericValue = parseFloat(sanitizedValue) || 0;

              const updatedItems = productInvoiceData.map(
                (item: any, i: any) => {
                  if (isForced === true) {
                    // updateProductInvoiceData(name, value, rowData.row.id);

                    if (i === +rowData.row?.id) {
                      return {
                        ...item,
                        [name]: numericValue // Use the sanitized value directly
                      };
                    }
                    // setTimeout(() => {
                    //   focusRef(`all_cost_${rowData.row.id}`);
                    // }, 50);

                    // return item; // No modifications in this case
                  } else {
                    if (i === +rowData.row?.id) {
                      const updatedItem = {
                        ...item,
                        [name]: numericValue
                      };

                      // Only update cost calculations if isForced is false
                      if (isTabToWhosale === false) {
                        updatedItem['all_cost'] =
                          (+package_amount * +ndsPrice) / 100 + +package_amount;
                      }

                      return updatedItem; // Ensure we return the modified object
                    }
                  }

                  return item; // Return unchanged item if not updated
                }
              );

              setProductInvoiceData(updatedItems);

              if (isTabToWhosale === false) {
                setTimeout(() => {
                  focusRef(`all_cost_${rowData.row.id}`);
                }, 50);
              }
            }
            setTimeout(() => {
              if (e.key === 'Tab' && barcodeInputRef.current) {
                barcodeInputRef.current.focus();
                barcodeInputRef.current.select();
              }
            }, 0);
          } else {
            if (e.key === 'Tab') {
              e.preventDefault(); // Prevent default Tab behavior

              const { name, value } = e.target as HTMLInputElement;
              const sanitizedValue = sanitizeValue(value); // Apply formatting
              const numericValue = parseFloat(sanitizedValue) || 0;

              const updatedItems = productInvoiceData.map(
                (item: any, i: any) => {
                  if (isForced === true) {
                    // updateProductInvoiceData(name, value, rowData.row.id);

                    if (i === +rowData.row?.id) {
                      return {
                        ...item,
                        [name]: numericValue // Use the sanitized value directly
                      };
                    }
                    // setTimeout(() => {
                    //   focusRef(`all_cost_${rowData.row.id}`);
                    // }, 50);

                    // return item; // No modifications in this case
                  } else {
                    if (i === +rowData.row?.id) {
                      const updatedItem = {
                        ...item,
                        [name]: numericValue
                      };

                      // Only update cost calculations if isForced is false
                      if (isTabToWhosale === false) {
                        updatedItem['all_cost'] =
                          (+package_amount * +ndsPrice) / 100 + +package_amount;
                      }

                      return updatedItem; // Ensure we return the modified object
                    }
                  }

                  return item; // Return unchanged item if not updated
                }
              );

              setProductInvoiceData(updatedItems);

              if (isTabToWhosale === false) {
                setTimeout(() => {
                  focusRef(`all_cost_${rowData.row.id}`);
                }, 50);
              }
            }
            setTimeout(() => {
              if (e.key === 'Enter' && barcodeInputRef.current) {
                barcodeInputRef.current.focus();
                barcodeInputRef.current.select();
              }
            }, 0);
          }
        };

        return (
          <div>
            <Form.Group>
              <Form.Control
                type="text"
                name="cost"
                value={value}
                onChange={handleChange}
                onBlur={(e: any) => onBlur(e, rowData.row?.id)}
                onFocus={e => e.target.select()}
                onKeyDown={handleKeyDown}
                ref={setRef(`cost_${rowData.row?.id}`)}
                autoComplete="off"
                style={{ textAlign: 'right' }}
              />
            </Form.Group>
          </div>
        );
      },
      meta: {
        cellProps: { className: 'text-900 p-1' }
      }
    },
    {
      accessorKey: 'all_cost',
      header: t('short_price'),
      cell: rowData => {
        const amount: any = rowData.getValue() ?? '0';
        const { package_amount } = rowData.row.original;

        /* prettier-ignore */
        const formatWithSpaces = (val: any) => {
          const cleanValue = String(val || '').replace(/[^0-9.]/g, ''); // Remove non-numeric chars except .
          if (!cleanValue) return '';
          const [integerPart, decimalPart] = cleanValue.includes('.')
            ? cleanValue.split('.')
            : [cleanValue, ''];
          const formattedInteger = integerPart.replace(
            /\B(?=(\d{3})+(?!\d))/g,
            ' '
          );
          return decimalPart
            ? `${formattedInteger}.${decimalPart}`
            : formattedInteger;
        };

        // Function to remove spaces for state storage
        const removeSpaces = (val: string) => {
          return val.replace(/\s/g, '');
        };

        const [value, setValue] = useState(formatWithSpaces(String(amount)));

        const updateProductInvoiceData = (
          name: string,
          sanitizedValue: string,
          index: any
        ) => {
          const numericValue = parseFloat(sanitizedValue) || 0;
          const updatedItems = productInvoiceData.map((item: any, i: any) => {
            if (i === +index) {
              return { ...item, [name]: numericValue };
            }
            return item;
          });

          setProductInvoiceData(updatedItems);
        };

        const sanitizeValue = (inputValue: string): string => {
          if (!inputValue) return '0';

          // Replace the first comma (if exists) with a dot (only if followed by a digit)
          let cleanedValue = removeSpaces(inputValue).replace(
            /(\d),(?=\d)/,
            '$1.'
          );

          // Remove all remaining commas
          cleanedValue = cleanedValue.replace(/,/g, '');

          // Ensure only one valid decimal point (keep only the last one)
          const parts = cleanedValue.split('.');
          if (parts?.length > 2) {
            cleanedValue =
              parts.slice(0, -1).join('') + '.' + parts[parts?.length - 1];
          }

          return cleanedValue || '0';
        };

        const onBlur = (e: React.ChangeEvent<HTMLInputElement>, index: any) => {
          const { name, value } = e.target;

          const sanitizedValue = sanitizeValue(value);

          updateProductInvoiceData(name, sanitizedValue, index);
          setValue(sanitizedValue);
        };

        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
          const newValue = e.target.value;
          const cleanValue = removeSpaces(newValue);
          const decimalPattern = /^-?\d*[.]?\d*$/;
          if (decimalPattern.test(cleanValue)) {
            setValue(formatWithSpaces(cleanValue));
          }
        };

        const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
          const { name, value: inputValue } = e.target as HTMLInputElement;

          if (isEnter) {
            if (e.key === 'Enter') {
              if (+ndsTransfer > 0) {
                e.preventDefault(); // Prevent default Tab behavior

                const { name, value } = e.target as HTMLInputElement;
                const sanitizedValue = sanitizeValue(value); // Apply formatting
                const numericValue = parseFloat(sanitizedValue) || 0;

                const updatedItems = productInvoiceData.map(
                  (item: any, i: any) => {
                    if (isForced === true) {
                      // updateProductInvoiceData(name, value, rowData.row.id);

                      if (i === +rowData.row?.id) {
                        return {
                          ...item,
                          [name]: numericValue // Use the sanitized value directly
                        };
                      }
                    } else {
                      if (i === +rowData.row?.id) {
                        const updatedItem = {
                          ...item,
                          [name]: numericValue
                        };

                        // Only update cost calculations if isForced is false
                        if (+ndsTransfer > 0) {
                          updatedItem['transfer_cost'] =
                            (+package_amount * +ndsTransfer) / 100 +
                            +package_amount;
                        }

                        return updatedItem; // Ensure we return the modified object
                      }
                    }

                    return item; // Return unchanged item if not updated
                  }
                );

                setProductInvoiceData(updatedItems);

                if (+ndsTransfer > 0) {
                  setTimeout(() => {
                    focusRef(`transfer_cost_${rowData.row.id}`);
                  }, 50);
                }
              } else {
                const sanitizedValue = sanitizeValue(inputValue); // Apply formatting
                updateProductInvoiceData(name, sanitizedValue, rowData.row?.id);

                const currentRowIndex = rowData.row.index;
                const nextRowIndex = currentRowIndex + 1;

                // Check if the current item is the last one
                if (nextRowIndex < productInvoiceData?.length) {
                  setTimeout(() => {
                    focusRef(`quantity_${nextRowIndex}`);
                  }, 50);
                } else {
                  // If it's the last item, move focus to the first item in the next column
                  setTimeout(() => {
                    focusRef(`quantity_0`);
                  }, 50);
                }
              }
            }
            setTimeout(() => {
              if (e.key === 'Tab' && barcodeInputRef.current) {
                barcodeInputRef.current.focus();
                barcodeInputRef.current.select();
              }
            }, 0);
          } else {
            if (e.key === 'Tab') {
              if (+ndsTransfer > 0) {
                e.preventDefault(); // Prevent default Tab behavior

                const { name, value } = e.target as HTMLInputElement;
                const sanitizedValue = sanitizeValue(value); // Apply formatting
                const numericValue = parseFloat(sanitizedValue) || 0;

                const updatedItems = productInvoiceData.map(
                  (item: any, i: any) => {
                    if (isForced === true) {
                      // updateProductInvoiceData(name, value, rowData.row.id);

                      if (i === +rowData.row?.id) {
                        return {
                          ...item,
                          [name]: numericValue // Use the sanitized value directly
                        };
                      }
                      // setTimeout(() => {
                      //   focusRef(`all_cost_${rowData.row.id}`);
                      // }, 50);

                      // return item; // No modifications in this case
                    } else {
                      if (i === +rowData.row?.id) {
                        const updatedItem = {
                          ...item,
                          [name]: numericValue
                        };

                        // Only update cost calculations if isForced is false
                        if (+ndsTransfer > 0) {
                          updatedItem['transfer_cost'] =
                            (+package_amount * +ndsTransfer) / 100 +
                            +package_amount;
                        }

                        return updatedItem; // Ensure we return the modified object
                      }
                    }

                    return item; // Return unchanged item if not updated
                  }
                );

                setProductInvoiceData(updatedItems);

                if (+ndsTransfer > 0) {
                  setTimeout(() => {
                    focusRef(`transfer_cost_${rowData.row.id}`);
                  }, 50);
                }
              } else {
                const sanitizedValue = sanitizeValue(inputValue); // Apply formatting
                updateProductInvoiceData(name, sanitizedValue, rowData.row?.id);

                const currentRowIndex = rowData.row.index;
                const nextRowIndex = currentRowIndex + 1;

                // Check if the current item is the last one
                if (nextRowIndex < productInvoiceData?.length) {
                  focusRef(`quantity_${nextRowIndex}`);
                } else {
                  // If it's the last item, move focus to the first item in the next column
                  focusRef(`quantity_0`);
                }
              }
            }
            setTimeout(() => {
              if (e.key === 'Enter' && barcodeInputRef.current) {
                barcodeInputRef.current.focus();
                barcodeInputRef.current.select();
              }
            }, 0);
          }
        };

        return (
          <div>
            <Form.Group>
              <Form.Control
                type="text"
                name="all_cost"
                value={value}
                onChange={handleChange}
                onBlur={(e: any) => onBlur(e, rowData.row?.id)}
                onFocus={e => e.target.select()}
                onKeyDown={handleKeyDown}
                ref={setRef(`all_cost_${rowData.row?.id}`)}
                autoComplete="off"
                style={{ textAlign: 'right' }}
              />
            </Form.Group>
          </div>
        );
      },
      meta: {
        cellProps: { className: 'text-900 p-1' }
      }
    },
    {
      accessorKey: 'transfer_cost',
      header: t('transfer'),
      cell: rowData => {
        const amount: any = rowData.getValue() ?? '0';

        /* prettier-ignore */
        const formatWithSpaces = (val: any) => {
          const cleanValue = String(val || '').replace(/[^0-9.]/g, ''); // Remove non-numeric chars except .
          if (!cleanValue) return '';
          const [integerPart, decimalPart] = cleanValue.includes('.')
            ? cleanValue.split('.')
            : [cleanValue, ''];
          const formattedInteger = integerPart.replace(
            /\B(?=(\d{3})+(?!\d))/g,
            ' '
          );
          return decimalPart
            ? `${formattedInteger}.${decimalPart}`
            : formattedInteger;
        };

        // Function to remove spaces for state storage
        const removeSpaces = (val: string) => {
          return val.replace(/\s/g, '');
        };

        const [value, setValue] = useState(formatWithSpaces(String(amount)));

        const updateProductInvoiceData = (
          name: string,
          sanitizedValue: string,
          index: any
        ) => {
          const numericValue = parseFloat(sanitizedValue) || 0;
          const updatedItems = productInvoiceData.map((item: any, i: any) => {
            if (i === +index) {
              return { ...item, [name]: numericValue };
            }
            return item;
          });

          setProductInvoiceData(updatedItems);
        };

        const sanitizeValue = (inputValue: string): string => {
          if (!inputValue) return '0';

          // Replace the first comma (if exists) with a dot (only if followed by a digit)
          let cleanedValue = removeSpaces(inputValue).replace(
            /(\d),(?=\d)/,
            '$1.'
          );

          // Remove all remaining commas
          cleanedValue = cleanedValue.replace(/,/g, '');

          // Ensure only one valid decimal point (keep only the last one)
          const parts = cleanedValue.split('.');
          if (parts?.length > 2) {
            cleanedValue =
              parts.slice(0, -1).join('') + '.' + parts[parts?.length - 1];
          }

          return cleanedValue || '0';
        };

        const onBlur = (e: React.ChangeEvent<HTMLInputElement>, index: any) => {
          const { name, value } = e.target;

          const sanitizedValue = sanitizeValue(value);

          updateProductInvoiceData(name, sanitizedValue, index);
          setValue(sanitizedValue);
        };

        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
          const newValue = e.target.value;
          const cleanValue = removeSpaces(newValue);
          const decimalPattern = /^-?\d*[.]?\d*$/;
          if (decimalPattern.test(cleanValue)) {
            setValue(formatWithSpaces(cleanValue));
          }
        };

        const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
          const { name, value: inputValue } = e.target as HTMLInputElement;

          if (isEnter) {
            if (e.key === 'Enter') {
              const sanitizedValue = sanitizeValue(inputValue); // Apply formatting
              updateProductInvoiceData(name, sanitizedValue, rowData.row?.id);

              const currentRowIndex = rowData.row.index;
              const nextRowIndex = currentRowIndex + 1;

              // Check if the current item is the last one
              if (nextRowIndex < productInvoiceData?.length) {
                setTimeout(() => {
                  focusRef(`quantity_${nextRowIndex}`);
                }, 50);
              } else {
                // If it's the last item, move focus to the first item in the next column
                setTimeout(() => {
                  focusRef(`quantity_0`);
                }, 50);
              }
            }
            setTimeout(() => {
              if (e.key === 'Tab' && barcodeInputRef.current) {
                barcodeInputRef.current.focus();
                barcodeInputRef.current.select();
              }
            }, 0);
          } else {
            if (e.key === 'Tab') {
              const sanitizedValue = sanitizeValue(inputValue); // Apply formatting
              updateProductInvoiceData(name, sanitizedValue, rowData.row?.id);

              const currentRowIndex = rowData.row.index;
              const nextRowIndex = currentRowIndex + 1;

              // Check if the current item is the last one
              if (nextRowIndex < productInvoiceData?.length) {
                focusRef(`quantity_${nextRowIndex}`);
              } else {
                // If it's the last item, move focus to the first item in the next column
                focusRef(`quantity_0`);
              }
            }
            setTimeout(() => {
              if (e.key === 'Enter' && barcodeInputRef.current) {
                barcodeInputRef.current.focus();
                barcodeInputRef.current.select();
              }
            }, 0);
          }
        };

        return (
          <div>
            {+ndsTransfer > 0 ? (
              <Form.Group>
                <Form.Control
                  type="text"
                  name="transfer_cost"
                  value={value}
                  onChange={handleChange}
                  onBlur={(e: any) => onBlur(e, rowData.row?.id)}
                  onFocus={e => e.target.select()}
                  onKeyDown={handleKeyDown}
                  ref={setRef(`transfer_cost_${rowData.row?.id}`)}
                  autoComplete="off"
                  style={{ textAlign: 'right' }}
                />
              </Form.Group>
            ) : (
              0
            )}
          </div>
        );
      },
      meta: {
        cellProps: {
          className: 'text-900 p-1'
        },
        headerProps: {}
      }
    },
    {
      accessorKey: 'total_amount_receipts',
      header: t('short_total_amount_receipts'),
      cell: rowData => {
        const { measure_unit_kind_pid } = rowData.row.original;

        const price = +rowData.row.original.package_amount || 0;
        const quantity = String(rowData.row.original?.quantity ?? '0');

        let integerPart = 0;
        let numerator = 0;
        let denominator = 0; // Default denominator to 1 if no fraction

        // Check if quantity contains '/'
        // eslint-disable-next-line
        if (quantity?.includes('/')) {
          // eslint-disable-next-line
          [numerator, denominator] = quantity?.split('/').map(Number);
          integerPart = numerator; // Whole number part
          // eslint-disable-next-line
          denominator = denominator; // Remainder of the division
        } else {
          integerPart = +quantity;
        }

        // Package quantity
        const packageQuantity = +rowData.row.original?.amount || 1;

        // Calculate adjusted quantity
        const adjustedQuantity =
          measure_unit_kind_pid === 1
            ? integerPart * packageQuantity + denominator
            : integerPart;

        const allCost =
          measure_unit_kind_pid === 1
            ? (price / packageQuantity) * +adjustedQuantity
            : price * +rowData.row.original?.quantity;
        return (
          <div>
            {allCost
              ? new Intl.NumberFormat('en-US', {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 4,
                  useGrouping: true
                })
                  .format(allCost)
                  .replace(/,/g, ' ')
              : 0}
          </div>
        );
      },
      meta: {
        cellProps: { className: 'text-900 p-1', style: { textAlign: 'right' } }
      }
    },
    {
      accessorKey: 'total_sale_amount',
      header: t('short_total_sale_amount'),
      cell: rowData => {
        const { measure_unit_kind_pid } = rowData.row.original;

        const price = +rowData.row.original.all_cost || 0;
        const quantity = String(rowData.row.original?.quantity ?? '0');

        let integerPart = 0;
        let numerator = 0;
        let denominator = 0; // Default denominator to 1 if no fraction

        // Check if quantity contains '/'
        // eslint-disable-next-line
        if (quantity?.includes('/')) {
          // eslint-disable-next-line
          [numerator, denominator] = quantity?.split('/').map(Number);
          integerPart = numerator; // Whole number part
          // eslint-disable-next-line
          denominator = denominator; // Remainder of the division
        } else {
          integerPart = +quantity;
        }

        // Package quantity
        const packageQuantity = +rowData.row.original?.amount || 1;

        // Calculate adjusted quantity
        const adjustedQuantity =
          measure_unit_kind_pid === 1
            ? integerPart * packageQuantity + denominator
            : integerPart;

        const allCost =
          measure_unit_kind_pid === 1
            ? (price / packageQuantity) * +adjustedQuantity
            : price * +rowData.row.original?.quantity;
        return (
          <div>
            {allCost
              ? new Intl.NumberFormat('en-US', {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 4,
                  useGrouping: true
                })
                  .format(allCost)
                  .replace(/,/g, ' ')
              : 0}
          </div>
        );
      },
      meta: {
        cellProps: { className: 'text-900 p-1', style: { textAlign: 'right' } }
      }
    },
    {
      accessorKey: 'update_price',
      header: t('short_update_prev_price'),
      cell: rowData => {
        const amount: any = rowData?.getValue() ?? false;
        const [value, setValue] = useState(amount);

        const handleCheckboxChange = (
          e: React.ChangeEvent<HTMLInputElement>,
          index: any
        ) => {
          const checked = e.target.checked;
          setValue(checked);

          const updatedItems = productInvoiceData.map((item: any, i: any) => {
            if (i === +index) {
              return { ...item, update_price: checked };
            }
            return item;
          });

          setProductInvoiceData(updatedItems);
        };
        return (
          <div>
            <Form.Group className="printing-check">
              <Form.Check
                type="switch"
                checked={value}
                onChange={e => handleCheckboxChange(e, rowData.row?.id)}
                className="cursor-pointer"
              />
            </Form.Group>
          </div>
        );
      },
      meta: {
        cellProps: { className: 'text-900 text-center' }
      }
    },

    {
      accessorKey: 'weght_code',
      header: t('short_weight_code'),
      cell: rowData => {
        const amount: any = rowData?.getValue() ?? '0';

        // it is id for check update or no (i check it to static Весовой 2604393f-4d7a-439d-9ee4-831756ad873b)
        const measureUnitKindId = rowData?.row?.original.measure_unit_kind_id;

        const [value, setValue] = useState(amount);

        const onBlur = (e: React.ChangeEvent<HTMLInputElement>, index: any) => {
          const { name, value } = e.target;
          const updatedItems = productInvoiceData.map((item: any, i: any) => {
            if (i === +index) {
              return { ...item, [name]: +value };
            }
            return item;
          });

          setProductInvoiceData(updatedItems);
        };

        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
          const newValue = e.target.value;
          if (/^\d*$/.test(newValue)) {
            // Allow empty string for intermediate state
            setValue(newValue);
          }
        };

        return (
          <div>
            {measureUnitKindId === '2604393f-4d7a-439d-9ee4-831756ad873b' ? (
              <Form.Group>
                <Form.Control
                  type="text"
                  name="weght_code"
                  value={value}
                  onChange={handleChange}
                  onBlur={(e: any) => onBlur(e, rowData.row?.id)}
                  onFocus={e => e.target.select()}
                />
              </Form.Group>
            ) : (
              <span className="ms-3">{amount}</span>
            )}
          </div>
        );
      },
      meta: {
        cellProps: { className: 'text-900 p-1' }
      }
    },

    {
      accessorKey: 'articul',
      header: t('article'),
      meta: {
        cellProps: { className: 'text-900 p-1' }
      }
    },
    {
      accessorKey: 'ikpu',
      header: t('ikpu_code'),
      meta: {
        cellProps: { className: 'text-900 p-1' }
      }
    },
    {
      accessorKey: 'party_number',
      header: t('short_party_number'),
      meta: {
        cellProps: { className: 'text-900 p-1' }
      }
    },
    {
      accessorKey: 'with_nds',
      header: t('with_vat'),
      meta: {
        cellProps: { className: 'text-900 p-1' }
      }
    },
    {
      accessorKey: 'category',
      header: t('category'),
      meta: {
        cellProps: { className: 'text-900 p-1' }
      }
    },
    {
      accessorKey: 'variation',
      header: t('variation'),
      meta: {
        cellProps: { className: 'text-900 p-1' }
      }
    },
    {
      accessorKey: 'barcode_original',
      header: t('barcode_original'),
      meta: {
        cellProps: { className: 'text-900 p-1' }
      }
    }
  ];

  const table = useAdvanceTable({
    data: productInvoiceData ?? [],
    columns: invoiceTableColumns,
    pageSize: 50,
    pagination: isPageDown ? false : true,
    sortable: true,
    selection: false
  });

  const tableIsPageDown = useAdvanceTable({
    data: productInvoiceData ?? [],
    columns: invoiceTableColumns,
    pageSize: 8000,
    pagination: isPageDown ? false : true,
    sortable: true,
    selection: false
  });

  const handleSave = async () => {
    // const aggregatedData = productInvoiceData.reduce((acc, item) => {
    //   const barcode = item?.barcode_user || '0';
    //   const quantityStr = String(item?.quantity || '0');
    //   let quantity = 0;

    //   // Parse quantity (handle fractional and integer cases)
    //   if (quantityStr.includes('/')) {
    //     const [numerator, denominator] = quantityStr.split('/').map(Number);
    //     quantity = numerator / denominator; // Convert fraction to decimal
    //   } else {
    //     quantity = +quantityStr; // Convert to number
    //   }

    //   if (!acc[barcode]) {
    //     // Initialize new entry for this barcode
    //     acc[barcode] = {
    //       ...item,
    //       quantity: 0, // Initialize quantity to 0 for summation
    //       originalQuantities: [] // Store original quantities for validation
    //     };
    //   }

    //   // Add quantity and store original quantity string
    //   acc[barcode].quantity += quantity;
    //   acc[barcode].originalQuantities.push(quantityStr);

    //   return acc;
    // }, {});

    // // Step 2: Convert aggregated data back to array and format quantities
    // const mergedProductInvoiceData = Object.values(aggregatedData).map(
    //   (item: any) => {
    //     const { quantity, originalQuantities, ...rest } = item;
    //     let adjustedQuantityStr = String(quantity);

    //     // If any original quantity was fractional, try to maintain fractional format
    //     if (originalQuantities.some((q: any) => q.includes('/'))) {
    //       // Convert decimal to fraction (simplified example, adjust as needed)
    //       const denominator = 100; // Example denominator for precision
    //       const numerator = Math.round(quantity * denominator);
    //       adjustedQuantityStr = `${numerator}/${denominator}`;
    //     } else {
    //       // If all quantities were integers, keep as integer
    //       adjustedQuantityStr = String(Math.round(quantity));
    //     }

    //     return {
    //       ...rest,
    //       quantity: adjustedQuantityStr
    //     };
    //   }
    // );
    const getheredData = productInvoiceData?.map((item: any) => {
      const quantity = item?.quantity || '0';

      let integerPart = 0;
      let numerator = 0;
      let denominator = 0; // Default denominator to 1 if no fraction

      const quantityStr = String(quantity);
      // Check if quantity contains '/'
      if (quantityStr?.includes('/')) {
        [numerator, denominator] = quantityStr.split('/').map(Number);

        integerPart = numerator; // Whole number part
        // eslint-disable-next-line
        denominator = denominator; // Remainder of the division
      } else {
        integerPart = +quantityStr;
      }

      // Package quantity
      const packageQuantity = +item?.amount || 1;

      // Calculate adjusted quantity
      const adjustedQuantity =
        item?.measure_unit_kind_pid === 1
          ? integerPart * packageQuantity + denominator
          : integerPart;

      return {
        name: item?.name.toString(),
        is_variation: item?.variation === t('yes') ? true : false,
        barcode: item?.barcode_user,
        scale_code: (item?.weght_code && +item?.weght_code) ?? 0,
        quantity:
          item?.measure_unit_kind_pid === 1 ? +adjustedQuantity : +quantity,
        package_quantity: (item?.amount && +item?.amount) ?? 0,
        price_in: (item?.package_amount && +item?.package_amount) ?? 0,
        price_whosale: (item?.cost && +item?.cost) ?? 0,
        price: (item?.all_cost && +item?.all_cost) ?? 0,
        price_enumeration: (item?.transfer_cost && +item?.transfer_cost) ?? 0,
        nomenclature_id: item?.guid,
        nomenclature_pid: item?.gupid || 0,
        update_price_in: item?.update_price ?? false,
        update_price: item?.update_price ?? false,
        sale_with_partion_code: item?.sale_with_partion_code ?? false,
        is_vat: isVatPayerValue,
        vat: +ndsData || 0,
        status_id: '5107ebe4-ae15-4707-b268-438d5366add1',
        status_pid: 1,
        from_excel: item?.from_excel,
        category_id: String(item?.category_id),
        measure_unit_id: String(item?.measure_unit_id),
        ikpu: String(item?.ikpu),
        articul: item?.articul,
        partion_number: String(item?.party_number),
        partion_codes: item?.serial_number
      };
    });

    //check for serial number
    const invalidSerialItems = getheredData
      .map((item, index) => ({ ...item, orderNumber: index + 1 }))
      .filter(
        item =>
          item.sale_with_partion_code === true &&
          (!item.partion_codes || item.partion_codes?.toString().trim() === '')
      );

    if (invalidSerialItems?.length > 0) {
      const invalidOrderNumbers = invalidSerialItems
        .map(item => item.orderNumber)
        .join(', ');
      console.log('Invalid serial items:', invalidSerialItems);
      /* prettier-ignore */
      dispatch(
        showAlert({
          title: `${t('please_complete_serial_number')}: ${invalidOrderNumbers}`,
          type: 'error'
        })
      );
      return;
    }

    // Check for empty name
    const invalidNameItems = getheredData
      .map((item, index) => ({ ...item, orderNumber: index + 1 }))
      .filter(
        item => typeof item?.name === 'string' && item?.name?.trim() === ''
      );

    if (invalidNameItems?.length > 0) {
      const invalidOrderNumbers = invalidNameItems
        .map(item => item.orderNumber)
        .join(', ');
      console.log('Invalid items found:', invalidNameItems);
      /* prettier-ignore */
      dispatch(
        showAlert({
          title: `${t('Name_not_empty_position_numbers')}: ${invalidOrderNumbers}`,
          type: 'error'
        })
      );
      return;
    }

    // Check for barcodes with a value of 0 and ensure category_id and measure_unit_id are present
    const invalidItems = getheredData
      .map((item, index) => ({ ...item, orderNumber: index + 1 }))
      .filter(
        item =>
          item.barcode === '0' && (!item.category_id || !item.measure_unit_id)
      );

    if (invalidItems?.length > 0) {
      const invalidOrderNumbers = invalidItems
        .map(item => item.orderNumber)
        .join(', ');
      console.log('Invalid items found:', invalidItems);
      dispatch(
        showAlert({
          title: `${t('error_missing_items')}: ${invalidOrderNumbers}`,
          type: 'error'
        })
      );
      return;
    }

    // Find duplicates by barcode, excluding barcodes with value 0
    // const barcodeCounts = getheredData.reduce(
    //   (
    //     acc: Record<number, { count: number; orderNumbers: number[] }>,
    //     item,
    //     index
    //   ) => {
    //     if (item.barcode !== 0) {
    //       if (!acc[item.barcode]) {
    //         acc[item.barcode] = { count: 0, orderNumbers: [] };
    //       }
    //       acc[item.barcode].count += 1;
    //       acc[item.barcode].orderNumbers.push(index + 1);
    //     }
    //     return acc;
    //   },
    //   {}
    // );

    // const duplicates = Object.entries(barcodeCounts)
    //   .filter(([, data]) => data.count > 1)
    //   .flatMap(([, data]) => data.orderNumbers);

    // if (duplicates.length > 0) {
    //   console.log('Duplicates found:', duplicates);
    //   /* prettier-ignore */
    //   dispatch(
    //     showAlert({
    //       title: `Обнаружены повторяющиеся штрих-коды! Номера позиций: ${duplicates.join(', ')}`,
    //       type: 'error'
    //     })
    //   );
    //   return;
    // }

    const chunkSize = 100;
    const chunks = [];

    for (let i = 0; i < getheredData?.length; i += chunkSize) {
      chunks.push(getheredData.slice(i, i + chunkSize));
    }

    const savedData = {
      invoice_id: newInvoiceId,
      invoice_pid: invoice_pid || 0,
      language: 'ru'
    };

    try {
      dispatch(showAlert({ title: `${t('saving_data')}...`, type: 'info' }));

      if (chunks?.length === 0) {
        chunks.push([]);
      }

      for (let i = 0; i < chunks?.length; i++) {
        setLoading(true);
        const dataToSend = {
          ...savedData,
          products: chunks[i],
          ...(i === 0 && { first_part: true }) // Add first_part: true for the first request
        };
        await productSearchService.createProduct(dataToSend);
      }

      dispatch(
        showAlert({
          title: `${t('purchase')} ${t('successfully_added')}`,
          type: 'success'
        })
      );

      dispatch(
        tableSavedDataActions.removeTableById({
          id: newInvoiceId
        })
      );
      setLoading(false);

      barcodeInputRef.current?.focus();
    } catch (error) {
      dispatch(showAlert({ title: t('error_saving'), type: 'error' }));
      setLoading(false);
    }
  };

  const handleFinish = async () => {
    // const aggregatedData = productInvoiceData.reduce((acc, item) => {
    //   const barcode = item?.barcode_user || '0';
    //   const quantityStr = String(item?.quantity || '0');
    //   let quantity = 0;

    //   // Parse quantity (handle fractional and integer cases)
    //   if (quantityStr.includes('/')) {
    //     const [numerator, denominator] = quantityStr.split('/').map(Number);
    //     quantity = numerator / denominator; // Convert fraction to decimal
    //   } else {
    //     quantity = +quantityStr; // Convert to number
    //   }

    //   if (!acc[barcode]) {
    //     // Initialize new entry for this barcode
    //     acc[barcode] = {
    //       ...item,
    //       quantity: 0, // Initialize quantity to 0 for summation
    //       originalQuantities: [] // Store original quantities for validation
    //     };
    //   }

    //   // Add quantity and store original quantity string
    //   acc[barcode].quantity += quantity;
    //   acc[barcode].originalQuantities.push(quantityStr);

    //   return acc;
    // }, {});

    // // Step 2: Convert aggregated data back to array and format quantities
    // const mergedProductInvoiceData = Object.values(aggregatedData).map(
    //   (item: any) => {
    //     const { quantity, originalQuantities, ...rest } = item;
    //     let adjustedQuantityStr = String(quantity);

    //     // If any original quantity was fractional, try to maintain fractional format
    //     if (originalQuantities.some((q: any) => q.includes('/'))) {
    //       // Convert decimal to fraction (simplified example, adjust as needed)
    //       const denominator = 100; // Example denominator for precision
    //       const numerator = Math.round(quantity * denominator);
    //       adjustedQuantityStr = `${numerator}/${denominator}`;
    //     } else {
    //       // If all quantities were integers, keep as integer
    //       adjustedQuantityStr = String(Math.round(quantity));
    //     }

    //     return {
    //       ...rest,
    //       quantity: adjustedQuantityStr
    //     };
    //   }
    // );
    // Conditionally check for zero fields based on saleToMinus
    // const zeroProductsData = saleToMinus
    //   ? []
    //   : productInvoiceData
    //       ?.map((product: any, index) => ({
    //         hasZero:
    //           product?.quantity === 0 ||
    //           product?.all_cost === 0 ||
    //           product?.cost === 0 ||
    //           product?.package_amount === 0,
    //         index: index + 1
    //       }))
    //       .filter(product => product.hasZero);

    // Check if there are any such products
    // if (!saleToMinus && zeroProductsData.length > 0) {
    //   const zeroProductOrderNumbers = zeroProductsData
    //     .map(p => p.index)
    //     .join(', ');
    //   dispatch(
    //     showAlert({
    //       title: `Количество и цены товаров должно быть больше нуля для завершения закупа. Проблема в позициях: ${zeroProductOrderNumbers}`,
    //       type: 'error'
    //     })
    //   );
    //   setConfirmToDelete(false);
    //   return;
    // }

    if (productInvoiceData?.length === 0) {
      dispatch(
        showAlert({
          title: t('product_not_added')
        })
      );
      setConfirmToDelete(false);
      return;
    }

    const getheredData = productInvoiceData?.map((item: any) => {
      const quantity = item?.quantity || '0';

      let integerPart = 0;
      let numerator = 0;
      let denominator = 0; // Default denominator to 1 if no fraction

      const quantityStr = String(quantity);
      // Check if quantity contains '/'
      if (quantityStr?.includes('/')) {
        [numerator, denominator] = quantityStr.split('/').map(Number);

        integerPart = numerator; // Whole number part
        // eslint-disable-next-line
        denominator = denominator; // Remainder of the division
      } else {
        integerPart = +quantityStr;
      }

      // Package quantity
      const packageQuantity = +item?.amount || 1;
      // Calculate the fractional proportion

      // Calculate adjusted quantity
      const adjustedQuantity =
        item?.measure_unit_kind_pid === 1
          ? integerPart * packageQuantity + denominator
          : integerPart;

      return {
        name: item?.name.toString(),
        is_variation: item?.variation === 'ДА' ? true : false,
        barcode: item?.barcode_user,
        scale_code: (item?.weght_code && +item?.weght_code) ?? 0,
        quantity:
          item?.measure_unit_kind_pid === 1 ? +adjustedQuantity : +quantity,
        package_quantity: (item?.amount && +item?.amount) ?? 0,
        price_in: (item?.package_amount && +item?.package_amount) ?? 0,
        update_price_in: item?.update_price ?? false,
        update_price: item?.update_price ?? false,
        sale_with_partion_code: item?.sale_with_partion_code ?? false,
        price_whosale: (item?.cost && +item?.cost) ?? 0,
        price: (item?.all_cost && +item?.all_cost) ?? 0,
        price_enumeration: (item?.transfer_cost && +item?.transfer_cost) ?? 0,
        nomenclature_id: item?.guid,
        nomenclature_pid: item?.gupid || 0,
        is_vat: isVatPayerValue,
        vat: +ndsData || 0,
        status_id: '1107ebe4-ae15-4707-b268-438d5366add5',
        status_pid: 5,
        from_excel: item?.from_excel,
        category_id: String(item?.category_id),
        measure_unit_id: String(item?.measure_unit_id),
        ikpu: String(item?.ikpu),
        articul: item?.articul,
        partion_number: String(item?.party_number),
        partion_codes: item?.serial_number
      };
    });

    //check for serial number
    const invalidSerialItems = getheredData
      .map((item, index) => ({ ...item, orderNumber: index + 1 }))
      .filter(
        item =>
          item.sale_with_partion_code === true &&
          (!item.partion_codes || item.partion_codes?.toString().trim() === '')
      );

    if (invalidSerialItems?.length > 0) {
      const invalidOrderNumbers = invalidSerialItems
        .map(item => item.orderNumber)
        .join(', ');
      console.log('Invalid serial items:', invalidSerialItems);
      /* prettier-ignore */
      dispatch(
        showAlert({
          title: `${t('please_complete_serial_number')}: ${invalidOrderNumbers}`,
          type: 'error'
        })
      );
      setConfirmToDelete(false);
      return;
    }

    // Check for empty name
    const invalidNameItems = getheredData
      .map((item, index) => ({ ...item, orderNumber: index + 1 }))
      .filter(
        item => typeof item?.name === 'string' && item?.name?.trim() === ''
      );

    if (invalidNameItems?.length > 0) {
      const invalidOrderNumbers = invalidNameItems
        .map(item => item.orderNumber)
        .join(', ');
      console.log('Invalid items found:', invalidNameItems);
      /* prettier-ignore */
      dispatch(
        showAlert({
          title: `${t('Name_not_empty_position_numbers')}: ${invalidOrderNumbers}`,
          type: 'error'
        })
      );
      setConfirmToDelete(false);
      return;
    }

    // Check for barcodes with a value of 0 and ensure category_id and measure_unit_id are present
    const invalidItems = getheredData
      .map((item, index) => ({ ...item, orderNumber: index + 1 }))
      .filter(
        item =>
          item.barcode === '0' && (!item.category_id || !item.measure_unit_id)
      );

    if (invalidItems?.length > 0) {
      const invalidOrderNumbers = invalidItems
        .map(item => item.orderNumber)
        .join(', ');
      console.log('Invalid items found:', invalidItems);
      dispatch(
        showAlert({
          title: `${t('error_missing_items')}: ${invalidOrderNumbers}`,
          type: 'error'
        })
      );
      setConfirmToDelete(false);
      return;
    }

    // Find duplicates by barcode, excluding barcodes with value 0
    // const barcodeCounts = getheredData.reduce(
    //   (
    //     acc: Record<number, { count: number; orderNumbers: number[] }>,
    //     item,
    //     index
    //   ) => {
    //     if (item.barcode !== 0) {
    //       if (!acc[item.barcode]) {
    //         acc[item.barcode] = { count: 0, orderNumbers: [] };
    //       }
    //       acc[item.barcode].count += 1;
    //       acc[item.barcode].orderNumbers.push(index + 1);
    //     }
    //     return acc;
    //   },
    //   {}
    // );

    // const duplicates = Object.entries(barcodeCounts)
    //   .filter(([, data]) => data.count > 1)
    //   .flatMap(([, data]) => data.orderNumbers);

    // if (duplicates.length > 0) {
    //   console.log('Duplicates found:', duplicates);
    //   /* prettier-ignore */
    //   dispatch( showAlert({ title: `Обнаружены повторяющиеся штрих-коды! Номера позиций: ${duplicates.join(', ')}`,
    //       type: 'error'
    //     })
    //   );
    //   setConfirmToDelete(false);
    //   return;
    // }

    // Check if any all_cost is greater than package_amount
    const highCostItems = getheredData
      .map((item: any, index) => ({ ...item, orderNumber: index + 1 }))
      .filter(item => item.price < item.price_in);

    console.log('getheredData', getheredData);
    /* prettier-ignore */
    if (highCostItems?.length > 0) {
      const highCostOrderNumbers = highCostItems
        .map(item => item.orderNumber)
        .join(', ');

      const confirmMessage = `${t('complited_goods_price_retail')}: ${highCostOrderNumbers}`;

      dispatch(
        showAlert({
          title: confirmMessage,
          type: 'warning'
        })
      );
      // setConfirmToDelete(false);
      // return;
    }

    const chunkSize = 100;
    const chunks = [];

    for (let i = 0; i < getheredData?.length; i += chunkSize) {
      chunks.push(getheredData.slice(i, i + chunkSize));
    }

    const savedData = {
      invoice_id: newInvoiceId,
      invoice_pid: invoice_pid || 0,
      language: 'ru'
    };

    if (
      productInvoiceData?.length > 0
      // && zeroProductsData.length === 0
    ) {
      setLoading(true);

      try {
        dispatch(
          showAlert({ title: `${t('data_completion')}...`, type: 'info' })
        );
        setOpenSupperModal(false);

        for (const [index, chunk] of chunks.entries()) {
          const dataToSend = {
            ...savedData,
            products: chunk,
            first_part: index === 0
          };
          await productSearchService.createProduct(dataToSend);
        }

        setOpenSupperModal(false);

        await invoiceService.updateInvoice(newInvoiceId, { status: true });

        dispatch(
          tableSavedDataActions.removeTableById({
            id: newInvoiceId
          })
        );

        navigate('/purchase/create');
        dispatch(
          showAlert({
            title: `${t('purchase')} ${t('successfully_added')}`,
            type: 'success'
          })
        );
        setLoading(false);
        setConfirmToDelete(false);

        barcodeInputRef.current?.focus();
      } catch (error) {
        if (error) {
          invoiceService.updateInvoiceWhenError({
            invoice_id: newInvoiceId,
            invoice_pid: invoice_pid || 0
          });
        }
        dispatch(
          showAlert({ title: t('error_while_completing'), type: 'error' })
        );
        setLoading(false);
        setConfirmToDelete(false);
      }
    }
  };

  const sumOfAllCost = productInvoiceData?.reduce((acc: any, item: any) => {
    const price = +item?.all_cost || 0;
    const quantity = String(item?.quantity ?? '0');

    let integerPart = 0;
    let numerator = 0;
    let denominator = 0; // Default denominator to 1 if no fraction

    // Check if quantity contains '/'
    // eslint-disable-next-line
    if (quantity?.includes('/')) {
      // eslint-disable-next-line
      [numerator, denominator] = quantity?.split('/').map(Number);
      integerPart = numerator; // Whole number part
      // eslint-disable-next-line
      denominator = denominator; // Remainder of the division
    } else {
      integerPart = +quantity;
    }

    // Package quantity
    const packageQuantity = +item?.amount || 1;

    const adjustedQuantity =
      item?.measure_unit_kind_pid === 1
        ? integerPart * packageQuantity + denominator
        : integerPart;

    const allCost =
      item?.measure_unit_kind_pid === 1
        ? (price / packageQuantity) * +adjustedQuantity
        : price * item?.quantity;
    return acc + allCost;
  }, 0);

  const sumOfPackageAmount = productInvoiceData?.reduce(
    (acc: any, item: any) => {
      const priceIn = +item?.package_amount || 0;
      const quantity = String(item?.quantity ?? '0');

      let integerPart = 0;
      let numerator = 0;
      let denominator = 0; // Default denominator to 1 if no fraction

      // Check if quantity contains '/'
      if (quantity?.includes('/')) {
        [numerator, denominator] = quantity.split('/').map(Number);
        integerPart = numerator; // Whole number part
        // eslint-disable-next-line
        denominator = denominator; // Remainder of the division
      } else {
        integerPart = +quantity;
      }

      // Package quantity
      const packageQuantity = +item?.amount || 1;

      const adjustedQuantity =
        item?.measure_unit_kind_pid === 1
          ? integerPart * packageQuantity + denominator
          : integerPart;

      const allCost =
        item?.measure_unit_kind_pid === 1
          ? (priceIn / packageQuantity) * +adjustedQuantity
          : priceIn * item?.quantity;
      return acc + allCost;
    },
    0
  );

  useEffect(() => {
    if (confirmToDelete) {
      handleFinish();
    }
  }, [confirmToDelete]);

  return (
    <div>
      <PageBreadcrumb items={invoceBreadcrumbItems} />
      <div>
        <h2 className="mb-5">{t('new')}</h2>

        <PrintingFilter
          newInvoiceId={newInvoiceId}
          productInvoiceData={productInvoiceData}
          modalCreate={modalCreate}
          setModalCreate={setModalCreate}
          isVatPayerValue={isVatPayerValue}
          setIsVatPayerValue={setIsVatPayerValue}
          ndsData={ndsData}
          setNdsData={setNdsData}
          setNdsPrice={setNdsPrice}
          ndsPrice={ndsPrice}
          setNdsPriceWholsale={setNdsPriceWholsale}
          ndsPriceWholsale={ndsPriceWholsale}
          setProductInvoiceData={setProductInvoiceData}
          barcodeInputRef={barcodeInputRef}
          focusRef={focusRef}
          setSaleToMinus={setSaleToMinus}
          saleToMinus={saleToMinus}
          setIsForced={setIsForced}
          setIsTabToWhosale={setIsTabToWhosale}
          setIsEnter={setIsEnter}
          setIsPageDown={setIsPageDown}
          tableRef={tableRef}
          isPageDown={isPageDown}
          setNdsTransfer={setNdsTransfer}
          ndsTransfer={ndsTransfer}
        />

        <AdvanceTableProvider {...(isPageDown ? tableIsPageDown : table)}>
          <div
            ref={tableRef}
            style={{
              ...(isPageDown &&
                productInvoiceData?.length > 4 && {
                  height: '500px', // Adjust height as needed
                  overflowY: `${loading ? 'hidden' : 'auto'}`, // Enables scrolling
                  border: '1px solid #ccc'
                })
            }}
            className="mt-4 mx-n4 px-4 mx-lg-n6 px-lg-6 bg-white border-top border-bottom border-300 position-relative top-1"
          >
            <AdvanceTable tableProps={{ className: 'phoenix-table fs-9' }} />
            <AdvanceTableFooter pagination />
            {loading && (
              <div className="loading-table">
                <span>
                  <Spinner
                    animation="border"
                    role="status"
                    style={{
                      color: '#8200BF',
                      width: '3rem',
                      height: '3rem'
                    }}
                  ></Spinner>
                </span>
              </div>
            )}
          </div>
        </AdvanceTableProvider>

        <SupperModal
          show={openSupperModal}
          setShow={setOpenSupperModal}
          setConfirm={setConfirmToDelete}
          title={t('purchase_invoice')}
          bodyText={t('want_complete_purchase')}
        />

        <div
          className={
            theme === 'dark' ? 'dark-footer-purchase' : 'footer-purchase'
          }
        >
          <div className="box">
            <p className="mb-0 text-bold">{t('total_amount_receipts')}</p>
            <span style={{ fontWeight: '800' }}>
              {sumOfPackageAmount
                ? new Intl.NumberFormat('en-US', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 4,
                    useGrouping: true
                  })
                    .format(sumOfPackageAmount)
                    .replace(/,/g, ' ')
                : 0}
            </span>
          </div>

          <div className="box">
            <p className="mb-0 text-bold">{t('total_sale_amount')}</p>
            <span style={{ fontWeight: '800' }}>
              {sumOfAllCost
                ? new Intl.NumberFormat('en-US', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 4,
                    useGrouping: true
                  })
                    .format(sumOfAllCost)
                    .replace(/,/g, ' ')
                : 0}
            </span>
          </div>

          <div className="box">
            <p className="mb-0 text-bold">{t('total_difference')}</p>
            <span style={{ fontWeight: '800' }}>
              {sumOfAllCost && sumOfPackageAmount
                ? new Intl.NumberFormat('en-US', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 4,
                    useGrouping: true
                  })
                    .format(sumOfAllCost - sumOfPackageAmount)
                    .replace(/,/g, ' ')
                : 0}
            </span>
          </div>

          <div className="d-flex gap-2">
            <Button
              variant="outline-primary"
              type="button"
              onClick={() => handleSave()}
              loading={loading}
            >
              {t('save')}
            </Button>
            <Button
              variant="primary"
              onClick={() => setOpenSupperModal(true)}
              loading={loading}
            >
              {t('complete')}
            </Button>
          </div>
        </div>
      </div>
      <Offcanvas
        show={openFillIn}
        onHide={() => {
          setOpenFillIn(false);
        }}
        placement="end"
        backdrop="static"
        keyboard={false}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title style={{ fontSize: '24px', fontWeight: '600' }}>
            {selectedRow?.serial_number?.length > 0 ? t('edit') : t('fill_in')}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <FillInInvoiceItem
            selectedRow={selectedRow}
            setOpenFillIn={setOpenFillIn}
            productInvoiceData={productInvoiceData}
            setProductInvoiceData={setProductInvoiceData}
          />
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default PurchaseInvoce;
